/**
 * Route: /earn-rate — Story 1.4 (Network Earn-Rate-Monitor UI)
 *
 * Referenz: claude-design-import/earn-rate.html. Die Seite selbst lebt in
 * features/earn-rate/EarnRatePage (Hero-Gauge + Stat-Strip, 30/90d-Chart mit
 * Floor-/Cap-Baendern, HIP-149/143-Erklaerbox).
 */
import { createFileRoute } from '@tanstack/react-router'
import { EarnRatePage } from '../features/earn-rate/EarnRatePage'

export const Route = createFileRoute('/_auth/earn-rate')({
  component: EarnRatePage,
})
